import { components } from "src/strapi/schema";
import { sortCategories } from "src/components/homepage/references/sortCategories";

export const getCategoriesFromReferences = (
  references: components["schemas"]["Reference"][],
) => {
  const categories = references.reduce(
    (acc, currentValue) => {
      const categories = currentValue.categories;
      if (!categories) return acc;
      categories.forEach((category) => {
        const { slug, id, name } = category;
        if (!slug || !id || !name) return acc;
        if (acc.some((accItem) => accItem.id === category.id)) {
          return acc;
        }
        acc.push({
          id,
          name,
          slug,
        });
      });
      return acc;
    },
    [] as { id: number; slug: string; name: string }[],
  );

  // sort by id
  return sortCategories(categories);
};
